import Icon from '@/components/snippets/icon/icon'
import { FilterSort } from 'libs/searchspring/components/collection/filters/FilterSort'
import { FilterButton } from 'libs/searchspring/components/collection/filters/FilterButton'
import { ProductCount } from 'libs/searchspring/components/collection/filters/ProductCount'
import { useFilters } from 'libs/searchspring/hooks/useFilters'

export const CollectionToolbar = () => {
  const {
    handleOpenFilters,
    handleToggleFilter,
    fetchedFilters,
    activeFilters,
    handleClearFilters
  } = useFilters()

  const activeFilterCount = activeFilters?.size

  const handleFilterDrawerOpen = () => {
    document.querySelectorAll('x-modal[data-id^="filter-"]').forEach(modal => {
      modal.removeAttribute('data-ui')
    })
    handleOpenFilters()
    document.querySelector('x-modal[data-id="filters"]')?.handleToggle()
  }

  return (
    <div className="collection-toolbar sticky top-header-adapt grid grid-cols-2 md:flex items-center justify-between md:gap-x-1 w-full h-[44px] md:px-margin bg-secondary border-b border-neutral-light z-40 has-[[data-ui=visible]]:md-max:z-60 transition-all">
      <div className="md:grow flex items-center md-max:justify-center md-max:w-full h-full md:-ml-margin md-max:border-r md-max:border-neutral-light">
        <div className="hidden md:flex items-center h-full children:first:pl-margin">
          {fetchedFilters.map((filter) => (
            <FilterButton
              filter={filter}
              activeFilters={activeFilters}
              onFilter={handleToggleFilter}
              fetchedFilters={fetchedFilters}
              onClick={handleFilterDrawerOpen}
              key={filter.field}
            />
          ))}
          {activeFilters.size > 0 && (
            <button
              className="flex items-center justify-center text-s leading-none font-medium text-neutral-secondary h-full px-1.5 link-line lined link-fade"
              onClick={handleClearFilters}
              aria-label="Clear All Filters"
              type="button"
            >
              <span>Clear All</span>
            </button>
          )}
        </div>
        <button
          id="toggle-filters"
          className="flex md:hidden items-center justify-center gap-x-0.625 size-full lg-max:px-margin link-fade"
          onClick={handleFilterDrawerOpen}
          aria-label="Toggle Filters"
        >
          <div class="w-[14px] h-[10px] children:size-full">
            <Icon id="filter" />
          </div>
          <span className="text-s font-bold">
            Filters{activeFilterCount > 0 ? ` (${activeFilterCount})` : ''}
          </span>
        </button>
      </div>

      <div className="md-max:hidden">
        <ProductCount />
      </div>

      <div className="md-max:flex md-max:items-center md-max:justify-center md-max:size-full">
        <FilterSort />
      </div>
    </div>
  )
}
